import { useMemo } from 'react'

import BasicTable from 'Components/UI/Atoms/BasicTable'

const toDisplayDate = (value) => {
  if (!value) return '00/00/0000'
  if (value instanceof Date && !Number.isNaN(value.getTime())) {
    return value.toLocaleDateString('es-AR')
  }
  const parsed = new Date(value)
  if (!Number.isNaN(parsed.getTime())) return parsed.toLocaleDateString('es-AR')
  return String(value)
}

const AsientosContent = (props) => {
  const { data } = props

  const rows = useMemo(() => {
    const src = Array.isArray(data?.asientos) ? data.asientos : []

    return src.map((row) => {
      const fecha = toDisplayDate(row.fecha)
      const parts = String(fecha).split('/')
      const periodo = parts.length === 3 ? `${parts[1]}/${parts[2]}` : '00/0000'

      const debeTotal = (row.detalles || []).reduce((acc, d) => acc + (Number(d.debe) || 0), 0)
      const haberTotal = (row.detalles || []).reduce((acc, d) => acc + (Number(d.haber) || 0), 0)

      return {
        id: row.id,
        fecha,
        periodo,
        descripcion: row.descripcion,
        debe: `$ ${debeTotal.toLocaleString('es-ES', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`,
        haber: `$ ${haberTotal.toLocaleString('es-ES', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`,
      }
    })
  }, [data])
  const hasRows = rows.length > 0

  return (
    <div style={{ display: 'flex', margin: '2rem', overflow: 'auto' }}>
      <div style={{ width: '100%' }}>
        {!hasRows && <div style={{ marginBottom: '1rem' }}>Sin asientos contables</div>}
        <BasicTable
          col={[
            { title: 'ID', style: { width: '40px' } },
            { title: 'Fecha', style: { width: '110px' } },
            { title: 'Periodo', style: { width: '90px' } },
            { title: 'Descripción', style: { width: '320px' } },
            { title: 'Debe', style: { width: '120px' } },
            { title: 'Haber', style: { width: '120px' } },
          ]}
          size="small"
          rows={rows}
          onClickRow={() => {}}
        />
      </div>
    </div>
  )
}

export default AsientosContent
